export enum PreCallInfo {
  CallFlow = 'CallFlow',
  Info = 'Info',
}
